var _linearGradient, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1904.46 1904.46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a8b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003489"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1780.49 86.7c-64.24-56.94-148.43-86.7-234.29-86.7h-1188.01c-85.85 0-170.03 29.77-234.27 86.73-82.6 73.25-123.92 163.37-123.92 270.35v1189.12c0 85.86 29.77 170.06 86.73 234.31 73.25 82.63 163.38 123.94 270.36 123.94h1190.71c75.8 0 151.39-21.78 210.99-68.62 97.11-76.33 145.67-172.51 145.67-288.48v-1190.27c0-106.99-41.33-197.15-123.96-270.38zm-584.17 1473.32-23.6-34.25-304.18-441.96-409.33 476.2h-100.94l465.27-541.53-378.58-550.05-85.33-124h349.87l23.6 34.28 284.72 413.65 298.9-347.89 86.41-100.04h100.94l-441.24 513.33 398.04 578.26 85.33 124h-349.87z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m964.48 854.45-296.56-430.88h-157.74l366.7 532.79 45 65.37 316.02 459.15h157.74l-386.16-561.06z",
    fill: "#f00",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.033925c0dccc1f0c3d5b1acfd670574c.svg";
export { ForwardRef as ReactComponent };